<template>
  <div class="chartWrap">
    <canvas id="chart">
      <Bar :chart-options="chartOptions" :chart-data="chartData" />
    </canvas>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onUpdated, PropType } from 'vue'

import { Bar } from 'vue-chartjs'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default defineComponent({
  name: 'CbtResultChart',
  components: { Bar },

  props: {
    title: {
      required: true
    },
    dateLabels: {
      type: Array as PropType<string[]>,
      required: true
    },
    scores: {
      type: Array as PropType<number[]>,
      required: true
    },
    maxScore: {
      type: Number,
      required: true
    }
  },

  setup(props) {
    const chartOptions = computed(() => {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: props.maxScore
          }
        },
        layout: {
          padding: 20
        },
        plugins: {
          legend: {
            display: true,
            align: 'start',
            labels: {
              boxHeight: 15,
              boxWidth: 40
            }
          }
        }
      }
    })

    const plugin = {
      beforeInit(chart: any) {
        const originalFit = chart.legend.fit
        chart.legend.fit = function fit() {
          originalFit.bind(chart.legend)()
          this.height += 24
        }
      }
    }

    const chartData = computed(() => {
      return {
        labels: props.dateLabels,
        datasets: [
          {
            label: props.title,
            backgroundColor: 'rgba(255,99,132,0.2)',
            data: props.scores
          }
        ]
      }
    })
    onUpdated(() => {
      const ctx = document.getElementById('chart') as HTMLCanvasElement
      /* eslint-disable */
      new ChartJS(ctx, {
        type: 'bar',
        // @ts-ignore
        data: chartData.value,
        // @ts-ignore
        options: chartOptions.value,
        // @ts-ignore
        plugins: [plugin]
      })
      /* eslint-enable */
    })

    return { chartOptions, chartData }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.chartWrap {
  width: 100%;
  max-width: calc(100% - 28px);
  height: 272px;
  background-color: #fff;
}
</style>
